import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import TimelineIcon from '@mui/icons-material/Timeline';
import TableChartIcon from '@mui/icons-material/TableChart';
import { SxProps, Tooltip } from '@mui/material';

type ViewType = "plot" | "table";

interface SwitchViewProps {
    value: ViewType;
    onChange: (value: ViewType) => void;
    sx?: SxProps;
}

const SwitchView: React.FC<SwitchViewProps> = ({ value, onChange, sx }) => {
    return (
        <ToggleButtonGroup value={value} onChange={(e, newValue) => onChange(newValue as ViewType)} size="small" exclusive sx={{ backgroundColor: "white", height: 32, ...sx }}>
            <Tooltip title="Diagrammansicht" placement="top">
                <ToggleButton value="plot" sx={{ height: 32, ...sx }}>
                    <TimelineIcon fontSize="small" />
                </ToggleButton>
            </Tooltip>
            <Tooltip title="Tabellenansicht" placement="top">
                <ToggleButton value="table" sx={{ height: 32, ...sx }}>
                    <TableChartIcon fontSize="small" />
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    )
}

export default SwitchView;